import { useEffect, useState } from 'react';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import { classNames } from '../../utils/classNames';
import Card from '../Reusable/Card';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
const StatusCard = (props: any) => {
  const { item, onClick, props: filterPrams, activeCard } = props;

  return (
    <Card
      onClick={() => {
        {
          item?.name === activeCard
            ? onClick('')
            : onClick(item?.id, item?.name);
        }
      }}
    >
      <div
        className={classNames(
          item?.name === activeCard ? tw`bg-primary-active text-primary` : tw``,
          tw`rounded-md h-full flex flex-col justify-between`
        )}
      >
        <div
          className={tw`uppercase text-primary font-semibold cursor-pointer mx-2 pt-2`}
        >
          {item?.name}
        </div>
        <div className={tw`flex flex-wrap justify-between mx-3 mt-4  `}>
          <div className={tw`font-medium text-lg`}>{item?.total_orders}</div>
          <div className={tw`font-medium text-lg`}>Rs.{item?.order_cod}</div>
        </div>
      </div>
    </Card>
  );
};

export default StatusCard;
